// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers. The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { SocialMediaModel } from "@synd/App/Services/socialMediaService";
import { Draft } from "immer";

export type xSocialMediaStateType = Readonly<{
    isLoading: boolean;
    posts: SocialMediaModel[];
    error?: string;
}>;

export const initialXSocialMediaState: xSocialMediaStateType = {
    isLoading: false,
    posts: [],
};

type CompleteLoad = { type: "xSocialMedia/CompleteLoad"; data: { posts: SocialMediaModel[] } };
type FailLoad = { type: "xSocialMedia/FailLoad"; data: { error?: string } };

const reducer = {
    "xSocialMedia/BeginLoad": (draft: Draft<xSocialMediaStateType>) => {
        draft.isLoading = true;
        draft.error = undefined;
    },
    "xSocialMedia/CompleteLoad": (draft: Draft<xSocialMediaStateType>, action: CompleteLoad) => {
        draft.isLoading = false;
        draft.posts = action.data.posts ?? [];
        draft.error = undefined;
    },
    "xSocialMedia/FailLoad": (draft: Draft<xSocialMediaStateType>, action: FailLoad) => {
        draft.isLoading = false;
        draft.error = action.data.error ?? "Failed to load social posts.";
    },
};

const xSocialMedia = createTypedReducerWithImmer(initialXSocialMediaState, reducer);
(reducers as any).xSocialMedia = xSocialMedia;

export type xSocialMediaState = { xSocialMedia: xSocialMediaStateType } & ApplicationState;
